import getConfig from '../../../helpers/config';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { SubjectData } from '../../../interfaces/profili-interface';
import {
  PaginationProps,
  PaginationReturn,
} from '../../../interfaces/pagination';
import { getPrepareHeaders } from '../get-prepare-headers';
import { LlojiLenda } from '../../../constants/enums/lloji-lenda';
import { VitiStudimit } from '../../../constants/enums/vitiStudimit';
import { SortType, UpdateProps } from '../../../interfaces/common-interfaces';
import { getCommonUrl } from '../../../components/common/common-functions/commonApiUrl/get-common-url';
import { ROLES } from '../../../constants/enums/roles';
import { LlojiKlasa } from '../../../utilities/enums';

const { test } = getConfig();

export interface LendaApiProps extends Partial<PaginationProps> {
  emri?: string;
  lendeKonkurimi?: boolean;
  sort?: SortType;
  llojiLenda?: LlojiLenda;
  llojiKlasa?: LlojiKlasa;
  vitiAkademikId?: number;
  vitiStudimit?: VitiStudimit;
  emriLenda?: string;
  roli?: string;
  pedagogu?: number;
  lendeGjyqKlinikaId?: number;
  lendeGjyqId?: number;
  lendaAkademikeId?: number;
  role?: ROLES;
}

export const lendaApi = createApi({
  reducerPath: 'lenda',
  baseQuery: fetchBaseQuery({
    baseUrl: test.baseUrl + `/`,
    prepareHeaders: getPrepareHeaders,
  }),
  tagTypes: ['Subject', 'GetAllSubjects'],
  endpoints: builder => ({
    getAllSubjects: builder.query<PaginationReturn<SubjectData>, LendaApiProps>(
      {
        query: args => getCommonUrl(args, 'lenda'),
        providesTags: ['GetAllSubjects'],
      },
    ),
    createSubject: builder.mutation<number, SubjectData>({
      query: data => ({
        url: `/lenda`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['GetAllSubjects'],
    }),
    getSingleSubject: builder.query<SubjectData, number>({
      query: id => ({
        url: `/lenda/${id}`,
        method: 'GET',
      }),
      providesTags: ['Subject'],
    }),
    updateSubject: builder.mutation<number, UpdateProps<SubjectData>>({
      query: args => ({
        url: `/lenda/${args.id}`,
        method: 'PUT',
        body: args.data,
      }),
      invalidatesTags: ['GetAllSubjects', 'Subject'],
    }),
    deleteSubject: builder.mutation<string, number>({
      query: id => ({
        url: `/lenda/${id}`,
        method: 'DELETE',
        responseHandler: response => response.text(),
      }),
      invalidatesTags: ['GetAllSubjects', 'Subject'],
    }),
  }),
});

export const {
  useGetAllSubjectsQuery,
  useLazyGetAllSubjectsQuery,
  useCreateSubjectMutation,
  useUpdateSubjectMutation,
  useLazyGetSingleSubjectQuery,
  useDeleteSubjectMutation,
} = lendaApi;
